// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"DataRequests_headerContainer__1jwtG","header":"DataRequests_header__1gz3F"};